import { render } from "./AdminLayout.vue?vue&type=template&id=b22292b2&scoped=true"
import script from "./AdminLayout.vue?vue&type=script&lang=js"
export * from "./AdminLayout.vue?vue&type=script&lang=js"

import "./AdminLayout.vue?vue&type=style&index=0&id=b22292b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b22292b2"]])

export default __exports__